import React, { useEffect } from 'react';
import { useSearchParams, useLocation } from 'react-router-dom';
import { useMessenger } from '../../context/messengerContext';

export default function AuthPanelHeader({backButton, backButtonCallback}) {
    const [searchParams] = useSearchParams();
    const location = useLocation();
    const { showBackButton, hideBackButton } = useMessenger();
    const first = searchParams.get('first') || location.state?.first;

    useEffect(() => {
        if (backButton && !first) {
            showBackButton(backButtonCallback);
        }
        return () => hideBackButton();
    }, [backButton, backButtonCallback, first]);

    return (
    <div className='main-panel-header-lang'>
    </div>
    );
}